// ─────────────────────────────────────────────────────────────────────────────
// Micro (SM 9020 B) test classification — the frontend mirror of the backend's
// `ControlChartReader.MicroCase` predicate. A microbiology test (Standard Methods
// 9200-series method, Colilert / Quanti-Tray / Tecta / SimPlate, or a coliform /
// E. coli / HPC / enterococci / Legionella name) charts under SM 9020 B rules
// instead of the chemistry Levey-Jennings ones. Deliberately broad, so a micro
// test is never mis-treated as chemistry.
//
// MIGRATION-TEMPORARY: this heuristic duplicates the backend LIKE list until a
// Department/Technology lookup (or a batch-level IsMicro flag from the reader)
// is wired — at which point this becomes a data flag and this file is deleted.
// Keep it IN LOCK-STEP with ControlChartReader.MicroCase.
// ─────────────────────────────────────────────────────────────────────────────

/** True when a batch's test / method is a microbiology (SM 9020 B) test. */
export function isMicroTest(test: string | null | undefined, method: string | null | undefined): boolean {
  const t = (test ?? "").toLowerCase();
  const m = (method ?? "").toLowerCase();
  return (
    m.startsWith("sm 92") ||
    m.includes("tecta") ||
    m.includes("simplate") ||
    m.includes("colilert") ||
    t.includes("colilert") ||
    t.includes("coliform") ||
    t.includes("e. coli") ||
    t.includes("hpc") ||
    t.includes("enterococc") ||
    t.includes("tecta") ||
    t.includes("hetero") ||
    t.includes("fecal") ||
    t.includes("simplate") ||
    t.includes("legionella") ||
    t.includes("quanti")
  );
}
